import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import FrameTV from "src/Component/FrameTV";
import PanelRight from "src/Component/PanelRight";
import ProfileAndTime from "src/Component/ProfileAndTime";
import useClock from "src/Hooks/useClock";

import profiles from "../../Component/TV/profiles.json";

const PageId = 10;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const baseImageBG = `${Config.BASE_URL}/images/BG/`;
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  const [step, setStep] = useState<number>(0);
  const baseImages = `${Config.BASE_URL}/images/screen_${PageId}/`;
  const rightSideImage_0 = `${baseImages}animation_0.jpg`;

  useEffect(() => {
    if (PageId === currentPage) setTimeout(() => setStep(1), 400);
    else setStep(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, currentPage]);

  const title = "Your Live TV, Anytime, Anywhere";

  const description =
    "Our cutting-edge technology ensures that all\nrecordings are effortlessly accessible from the\ncloud, allowing you to watch your favorite\nprograms on any device from anywhere in the\nworld.\n\nTo offer maximum flexibility, we offer several\nrestrictions, including quota in hours, retention\nperiod, trickplay restrictions, channel & event\nblackouts, and playout restrictions.";

  const currentUser = useSelector(() => store.getState().appReducer.currentUser);
  const currentProfile = profiles.find((profile) => profile.key === currentUser);

  const time = useClock();

  return {
    bgImage: `${baseImageBG}BG_2.jpg`,
    title,
    description,
    rightSideComponent: (
      <PanelRight>
        <FrameTV>
          <ProfileAndTime bg={rightSideImage_0} time={time} currentProfile={currentProfile} />
        </FrameTV>
      </PanelRight>
    ),
    back: {
      label: "Back",
      type: "back",
      startIcon: { icon: "arrow-right", color: "#fff" },
      onClick: () => setCurrentPage(BackPageId),
      style: { gap: "var(--width-16)" },
    },
    next: {
      label: "Continue",
      type: "next",
      endIcon: { icon: "arrow-left" },
      onClick: () => setCurrentPage(NextPageId),
      style: { gap: "var(--width-16)" },
    },
  };
};

export default DATA;
